export const RATE_WIDGET_IDS = new Set([
  "EMAIL_OPEN_RATE",
  "EMAIL_REPLY_RATE",
  "CONNECT_RATE",
  "LINKEDIN_REPLY_RATE"
]);

// Category → API endpoint key mapping
export const CATEGORY_ENDPOINT_MAP = {
  EMAIL: "getDashboardWidgetsEmail",
  CALLING: "getDashboardWidgetsCalling",
  LINKEDIN: "getDashboardWidgetsLinkedin",
  TASKS: "getDashboardWidgetsTasks",
  OVERVIEW: "getDashboardWidgetsOverview",
  CONTACTS: "getDashboardWidgetsContacts"
};

// Category → display label
export const CATEGORY_LABEL = {
  EMAIL: "Email",
  CALLING: "Calling",
  LINKEDIN: "LinkedIn",
  TASKS: "Tasks",
  OVERVIEW: "Overview",
  CONTACTS: "Contacts"
};

// Category → CSS class suffix for color-coded badges (see _widgetCard.scss)
export const CATEGORY_COLOR_CLASS = {
  EMAIL: "email",
  CALLING: "calling",
  LINKEDIN: "linkedin",
  TASKS: "tasks",
  OVERVIEW: "overview",
  CONTACTS: "contacts"
};

// Widget metadata: label, category, isRate, valueKey in API response, trendKey
export const WIDGET_META = {
  EMAILS_SENT: {
    label: "Emails Sent",
    category: "EMAIL",
    isRate: false,
    valueKey: "emailsSent",
    trendKey: "emailsSentTrend",
    seriesKey: "emailsSentSeries",
    metrics: ["Sent"]
  },
  EMAIL_OPEN_RATE: {
    label: "Email Open Rate",
    category: "EMAIL",
    isRate: true,
    valueKey: "currentRate",
    trendKey: "trend",
    bottomStatKey: null,
    metrics: ["Opens", "Open rate"]
  },
  EMAIL_REPLY_RATE: {
    label: "Email Reply Rate",
    category: "EMAIL",
    isRate: true,
    valueKey: "currentRate",
    trendKey: "trend",
    bottomStatKey: null,
    metrics: ["Replies", "Reply rate"]
  },
  BOUNCES: {
    label: "Bounces",
    category: "EMAIL",
    isRate: false,
    valueKey: "emailsBounceCount",
    trendKey: "emailsBounceCountTrend",
    seriesKey: "emailsBounceCountSeries",
    metrics: ["Bounce rate"]
  },
  MANUAL_EMAILS_SENT: {
    label: "Manual Emails Sent",
    category: "EMAIL",
    isRate: false,
    valueKey: "manualEmailsSent",
    trendKey: "manualEmailsSentTrend",
    seriesKey: "manualEmailsSentSeries",
    metrics: ["Sent"]
  },
  SEQUENCE_EMAILS_SENT: {
    label: "Sequence Emails Sent",
    category: "EMAIL",
    isRate: false,
    valueKey: "sequenceEmailsSent",
    trendKey: "sequenceEmailsSentTrend",
    seriesKey: "sequenceEmailsSentSeries",
    metrics: ["Sent", "Open rate", "Reply rate"]
  },
  LATEST_REPLIES: {
    label: "Latest Replies",
    category: "EMAIL",
    isRate: false,
    isListWidget: true,
    valueKey: null,
    trendKey: null,
    metrics: ["Latest replies"]
  },
  CALLS_CONNECTED: {
    label: "Calls Connected",
    category: "CALLING",
    isRate: false,
    valueKey: "callsConnected",
    trendKey: "callsConnectedTrend",
    seriesKey: "callsConnectedSeries",
    metrics: ["Connected"]
  },
  CONNECT_RATE: {
    label: "Connect Rate",
    category: "CALLING",
    isRate: true,
    valueKey: "currentRate",
    trendKey: "trend",
    bottomStatKey: null,
    metrics: ["Connect rate"]
  },
  CALL_OUTCOMES: {
    label: "Call Outcomes",
    category: "CALLING",
    isRate: false,
    valueKey: "callOutcomes",
    trendKey: null,
    metrics: ["Connected", "Voicemail", "No answer"]
  },
  CALLS_BY_MEMBER: {
    label: "Calls by Member",
    category: "CALLING",
    isRate: false,
    valueKey: "callsByMember",
    trendKey: null,
    metrics: ["Calls made", "Connected"]
  },
  TOTAL_CALLING_MINUTES: {
    label: "Total Calling Minutes",
    category: "CALLING",
    isRate: false,
    valueKey: "totalCallingMinutes",
    trendKey: "totalCallingMinutesTrend",
    seriesKey: "totalCallingMinutesSeries",
    metrics: ["Total duration"]
  },
  TOTAL_CALLS_MADE: {
    label: "Total Calls Made",
    category: "CALLING",
    isRate: false,
    valueKey: "callsMade",
    trendKey: "callsMadeTrend",
    seriesKey: "callsMadeSeries",
    metrics: ["Calls made"]
  },
  AVG_CALL_DURATION: {
    label: "Avg Call Duration",
    category: "CALLING",
    isRate: false,
    valueKey: "avgCallDuration",
    trendKey: "avgCallDurationTrend",
    seriesKey: null,
    metrics: ["Avg duration"]
  },
  CONNECTIONS_SENT: {
    label: "Connections Sent",
    category: "LINKEDIN",
    isRate: false,
    valueKey: "connectionsSent",
    trendKey: "connectionsSentTrend",
    seriesKey: "connectionsSentSeries",
    metrics: ["Connections sent"]
  },
  CONNECTIONS_ACCEPTED: {
    label: "Connections Accepted",
    category: "LINKEDIN",
    isRate: false,
    valueKey: "connectionsAccepted",
    trendKey: "connectionsAcceptedTrend",
    seriesKey: "connectionsAcceptedSeries",
    metrics: ["Accepted"]
  },
  // Retired from the widget catalog in favor of TOTAL_LINKEDIN_MESSAGES_SENT /
  // LINKEDIN_REPLIES_RECEIVED below - kept here so dashboards that already have it keep rendering.
  LINKEDIN_OVERVIEW: {
    label: "LinkedIn Overview",
    category: "LINKEDIN",
    isRate: false,
    valueKey: "linkedinOverview",
    trendKey: null,
    metrics: ["Connections sent", "Accepted", "Replies"]
  },
  TOTAL_LINKEDIN_MESSAGES_SENT: {
    label: "Total LinkedIn Messages Sent",
    category: "LINKEDIN",
    isRate: false,
    valueKey: "linkedinMessagesSent",
    trendKey: "linkedinMessagesSentTrend",
    seriesKey: "linkedinMessagesSentSeries",
    metrics: ["Messages sent"]
  },
  LINKEDIN_REPLIES_RECEIVED: {
    label: "LinkedIn Replies Received",
    category: "LINKEDIN",
    isRate: false,
    valueKey: "linkedinRepliesReceived",
    trendKey: "linkedinRepliesReceivedTrend",
    seriesKey: "linkedinRepliesReceivedSeries",
    metrics: ["Replies received"]
  },
  LINKEDIN_REPLY_RATE: {
    label: "LinkedIn Reply Rate",
    category: "LINKEDIN",
    isRate: true,
    valueKey: "currentRate",
    trendKey: "trend",
    bottomStatKey: null,
    metrics: ["Replies", "Reply rate"]
  },
  TASKS_DUE: {
    label: "Tasks Due",
    category: "TASKS",
    isRate: false,
    valueKey: "tasksDue",
    trendKey: "tasksDueTrend",
    seriesKey: null,
    metrics: ["Due"]
  },
  TASKS_COMPLETED: {
    label: "Tasks Completed",
    category: "TASKS",
    isRate: false,
    valueKey: "tasksCompleted",
    trendKey: "tasksCompletedTrend",
    seriesKey: null,
    metrics: ["Completed"]
  },
  MEETINGS_BOOKED: {
    label: "Meetings Booked",
    category: "OVERVIEW",
    isRate: false,
    valueKey: "meetingsBooked",
    trendKey: "meetingsBookedTrend",
    seriesKey: "meetingsBookedSeries",
    metrics: ["Connected"]
  },
  CONTACTS_ADDED_TO_SEQUENCE: {
    label: "Contacts Added to Sequence",
    category: "CONTACTS",
    isRate: false,
    valueKey: "contactsAddedToSequence",
    trendKey: "contactsAddedToSequenceTrend",
    seriesKey: "contactsAddedToSequenceSeries",
    metrics: ["Contacts added"]
  }
};

// Presets with exactly one day in range - rendered as a single-point chart (one x-axis category)
export const SINGLE_DAY_PRESETS = new Set(["today", "yesterday"]);

// Presets that use weekday (7-bucket) charts
export const WEEKDAY_CHART_PRESETS = new Set(["lastWeek", "7d"]);

// Presets that use weekly (4-bucket) charts
export const WEEKLY_CHART_PRESETS = new Set(["30d", "thisMonth"]);

export const WEEKDAY_LABELS = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
export const WEEK_LABELS = ["1st Week", "2nd Week", "3rd Week", "4th Week"];
